// extracted by css-extract-rspack-plugin
export default {"preview-text-content":"PreviewTextContent_preview-text-content__8k45w","scrollable":"PreviewTextContent_scrollable__a-d8i","title":"PreviewTextContent_title__xEkS3"};